import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { FlagResponse } from '@models/flag-response';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  constructor(
    private http: HttpClient,
  ) {}

  getFeatureToggles(): Observable<FlagResponse> {
    const url = `${environment.backend_server_url_account}/guest/feature-toggles`;
    return this.http.get<FlagResponse>(url);
  }

  isAvailable(version): Observable<any> {
    const url = `${environment.backend_server_url_account}/guest/isAvailable/${version}`;
    return this.http.get(url);
  }
}
